// extracted by mini-css-extract-plugin
export default {"MovieCountdown":"MovieCountdown_MovieCountdown__nNAtK","expandCircle":"MovieCountdown_expandCircle__G354Y"};